<template>
  <modal @close_modal="close_modal" :title="$t('set_jobs.details')" :loading="loading"
  >
    <template v-slot:content>
      <div class="log-content">{{text}}</div>
    </template>
  </modal>
</template>

<script>
import Modal from "@/components/Modal";
export default {
  name: "TextInModal",
  data () {
    return {
      'loading': false,
    }
  },
  methods: {
    close_modal() {
      this.$emit('close_modal')
    }
  },
  computed: {
  },
  components: {Modal},
  props: {
    text: {required: true},
  }
}
</script>

<style scoped>
.log-content {
  white-space: pre-wrap;
  word-wrap: break-word;
  font-family: monospace;
  background-color: #f5f5f5;
  padding: 10px;
  border-radius: 4px;
  max-height: 400px;
  overflow-y: auto;
}
</style>